import * as React from 'react';
const SvgZoom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="m19.647 18.237-3.041-3.042a7 7 0 0 0 1.4-4.192A7 7 0 0 0 11.004 4 7 7 0 0 0 4 11.003a6.998 6.998 0 0 0 11.195 5.603l3.042 3.041c.2.2.3.3.41.33.1.03.21.03.31 0 .05-.02.1-.04.15-.09.07-.06.15-.14.26-.25l.28-.28c.2-.2.3-.3.33-.41.03-.1.03-.21 0-.31-.04-.11-.14-.21-.33-.41zm-8.644-2.231a5.004 5.004 0 0 1-5.002-5.003 5.004 5.004 0 0 1 5.002-5.002 5.004 5.004 0 0 1 5.003 5.002 5.004 5.004 0 0 1-5.003 5.003"
    />
  </svg>
);
export default SvgZoom;
